import { Sidecar } from '@eppendorf/vnls-react-components';
import { ReactElement, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { LoadingErrorHint } from '$components/loading-error-hint/loading-error-hint';
import { NotificationRuleDetailWrapper } from '$features/notifications/detail/notification-detail-wrapper';
import { useGetNotificationRule } from '$features/notifications/notification-rules.api';

export function NotificationDetailSidecar(): ReactElement {
  const [searchParams] = useSearchParams();

  const [isSidecarOpen, setIsSidecarOpen] = useState(true);

  const navigate = useNavigate();

  const { data } = useGetNotificationRule(searchParams.get('id') || '');

  function handleSidecarOpenChange(): void {
    setIsSidecarOpen(false);
    navigate({
      search: '',
    });
  }

  return (
    <Sidecar isOpen={isSidecarOpen} onOpenChange={() => handleSidecarOpenChange()}>
      <div className="flex flex__dir--column flex__ai--stretch h-full">
        {!data && <LoadingErrorHint className="m-top-xl" />}
        {data && <NotificationRuleDetailWrapper data={data} />}
      </div>
    </Sidecar>
  );
}
